export const environment = {
  production: false,
  auth: {
    bypassAuthentication: false, // Disable bypass to use real Twitch auth
    bypassToken: 'fdksljuhf98u54jnw98fjd9s8aamcoi1ju498nmzxo8cjn0982qj5riunq',
    twitchClientId: 'mpqzbw5i6yx7oowzfwnhlpk9uyk288',
    twitchAuthUrl: 'https://id.twitch.tv/oauth2/authorize'
  },
  api: {
    baseUrl: 'https://c7emeb4smf.execute-api.us-east-1.amazonaws.com'
  },
  websocket: {
    url: 'wss://7ekzw8yp9d.execute-api.us-east-1.amazonaws.com/dev'
  }
};
